<template>
  <div class="see-more-wrapper" @click="closeWrapper" ref="seeMoreWrapper">
    <div :class="{'see-more-box': true, closeAnimation}">

      <div class="top-row">
        <div class="title">See More</div>
        <div class="close">
          <font-awesome-icon icon="times" class="icon" @click="close"/>
        </div>
      </div>

      <div class="bottom-row">

        <div class="text-box">
          You must be logged in to your Frogero account to view more dialogues
        </div>

        <div class="buttons-box">
          <button class="login" @click="onLogin">Login</button>
          <button class="signUp" @click="onSignUp">Create Free Account</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SettingsWrapper',
  data() {
    return {
      closeAnimation: false
    }
  },
  methods: {
    closeWrapper(event) {
      if(event.target == this.$refs.seeMoreWrapper) {
        this.close();
      }
    },
    close() {
      this.closeAnimation = true;
      setTimeout(() => {
        this.$emit('close');
      }, 300);
    },
    onLogin() {
      this.$emit('login');
    },
    onSignUp() {
      this.$emit('signUp');
    }
  }
}
</script>

<style lang="scss" scoped>
  .see-more-wrapper {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #2526295b;
    z-index: 90;
    display: flex;
    justify-content: center;
    align-items: center;

    .see-more-box {
      z-index: 100;
      width: 30rem;
      height: auto;
      background-color: whitesmoke;
      border-radius: 0.2rem;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      animation: open 0.5s forwards;

      @media (max-width: 600px) {
        width: 90vw;
        height: 20rem;
        position: absolute;
        top: 10rem;
      }

      @keyframes open {
        0% {
          opacity: 0;
          transform: translateY(5rem);
        }
        100% {
          opacity: 1;
          transform: translateY(0rem);
        }
      }
    }

    .closeAnimation {
      animation: close 0.5s forwards;

      @keyframes close {
        0% {
          opacity: 1;
          transform: translateY(0rem);
        }
        100% {
          opacity: 0;
          transform: translateY(-5rem);
        }
      }
    }

    .top-row {
      width: 100%;
      height: 5rem;
      background-color: #11b6a5;
      display: flex;
      flex-direction: row;

      .title {
        flex: auto;
        height: 100%;
        display: flex;
        align-items: center;
        color: white;
        font-size: 1.5rem;
        padding-left: 2rem;
      }

      .close {
        width: 5rem;
        height: 5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 1.2rem;

        .icon {
          transition: 0.2s;

          &:hover {
            opacity: 0.8;
            cursor: pointer;
          }
        }
      }
    }

    .bottom-row {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media (max-width: 600px) {
        height: 15rem;
      }
    }
  }

  .text-box {
    font-size: 1.2rem;
    color: #a0a0a0;
    padding-left: 2rem;
    padding-right: 2rem;
    line-height: 1.7rem;
    letter-spacing: 0.08rem;
    text-align: center;
    margin-top: 2rem;
  }

  .buttons-box {
    width: 100%;
    height: 4rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login {
    width: 6rem;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.3s;
    background: none;
    outline: none;
    border: none;
    color: white;
    font-weight: bold;
    font-size: 1.2rem;
    background-color: #0f978a;
    border-radius: 0.2rem;
    margin-right: 1rem;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }

  .signUp {
    width: auto;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.3s;
    background: none;
    outline: none;
    border: none;
    color: white;
    font-weight: bold;
    font-size: 1.2rem;
    background-color: #e6c17d;
    border-radius: 0.2rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
</style>